<div class="retail-place-info" *ngIf="retailPlace" data-qa-block="retail-place-info">
  <span class="retail-place-name" data-qa="retail-place-name">{{ retailPlace.title }}</span>
  <span class="grey-text" data-qa="retail-place-address">{{ retailPlace.address }}</span>
</div>

<div class="status" *ngIf="kkm" data-qa-block="kkm-info">
  <div
    class="reg_status"
    *ngIf="kkm.regStatus && kkmRegStatuses[kkm.regStatus]"
    data-qa="kkm-reg-status-info"
  >
    {{ kkmRegStatuses[kkm.regStatus] | translate }} {{ kkm.regStatusChangedAt | dateTime }}
  </div>
  <span class="serial_number grey-text" data-qa="kkm-serial-number"
    >ЗН: {{ kkm?.serialNumber }}</span
  >
  <span class="kkm_id grey-text" data-qa="kkm-id">id: {{ kkm?.id }}</span>
  <div class="billing_status" *ngIf="kkm.billingStatus && kkmBillingStatuses[kkm.billingStatus]">
    <span
      class="{{ kkmBillingStatuses[kkm.billingStatus].className }}"
      data-qa="billing-status-info"
    >
      {{ kkmBillingStatuses[kkm.billingStatus].text | translate }}
      {{ kkm.billingStatusChangedAt | dateTime }}
    </span>
  </div>
</div>
